import { IDocumentTable, IRow, IRows } from '@models/Forms/IForms';
import { collectTableColumns } from '@molecules/formbuilder/controls/Table/controls/tableColumns';

/** Ограничения колонок действуют и в customForm; кэш общей схемы не меняем. */
export const applyTableDisplayMode = (scheme: IRows | undefined, table: IDocumentTable): IRows | undefined => {
    if (!scheme) return scheme;
    const keys = new Set(
        collectTableColumns(table)
            .filter(({ column }) => column.displayMode === 'view')
            .map(({ column }) => column.key),
    );
    for (const child of table.tables ?? []) if (child.displayMode === 'view') keys.add(child.key);
    if (!keys.size) return scheme;
    const mapFields = <T extends { key: string }>(items: T[] | undefined): T[] | undefined =>
        items?.map((field) => (keys.has(field.key) ? { ...field, displayMode: 'view' } : field));
    const mapRows = (rows: IRow[] | undefined): IRow[] | undefined =>
        rows?.map(
            (row) =>
                row && {
                    ...row,
                    columns: row.columns?.map((column) => ({
                        ...column,
                        fields: mapFields(column.fields)!,
                        dicts: mapFields(column.dicts)!,
                        abooks: mapFields(column.abooks)!,
                        calcs: mapFields(column.calcs)!,
                        autoCompletes: mapFields(column.autoCompletes)!,
                        tables: mapFields(column.tables)!,
                        rows: mapRows(column.rows)!,
                        blocks: column.blocks?.map((block) => ({
                            ...block,
                            rows: { ...block.rows, row: mapRows(block.rows?.row)! },
                        })),
                        editInModals: column.editInModals?.map((modal) => ({
                            ...modal,
                            rows: { ...modal.rows, row: mapRows(modal.rows?.row)! },
                        })),
                    })),
                },
        );
    return { ...scheme, rows: { ...scheme.rows, row: mapRows(scheme.rows.row)! } };
};
